import * as React from 'react';
import { isValidNumber, constrainToRange, determinePercentageIntoRange } from 'utils/numberUtils';

export interface IBudgetBarProps {
    budgetType?: string;
    className?: string;
    spent: number;
    total: number;
}

export class BudgetBar extends React.Component<IBudgetBarProps> {
    constructor(props: IBudgetBarProps) {
        super(props);
    }

    render(): React.ReactNode {
        const { spent, total } = this.props;
        const className = this.props.className || '';
        const budgetType = this.props.budgetType || 'budget-default';
        // provide actual numbers, please
        if (!isValidNumber(spent) || !isValidNumber(total)) {
            return null;
        }
        // positive numbers and zeroes only, please
        const spentNum = spent <= 0 ? 0 : spent;
        const totalNum = total <= 0 ? 0 : total;
        const percentageSpent = this.determinePercentageWidth(spentNum, totalNum);
        const overBudgetClass = spentNum > totalNum ? 'budget-bar--overspent' : '';
        const fullBudgetClass = percentageSpent === 100 ? 'budget-bar--full' : '';
        const emptyBudgetClass = percentageSpent === 0 ? 'budget-bar--empty' : '';
        const combinedClass = `${className} ${budgetType} ${fullBudgetClass} ${emptyBudgetClass} ${overBudgetClass}`;
        const budgetFilledStyle = {
            width: `${percentageSpent}%`
        };

        return (
            <div
                className={`budget-bar ${combinedClass}`}
            >
                <div className="budget-bar__total">
                    <div className="budget-bar__spent" style={budgetFilledStyle} />
                </div>
            </div>
        );
    }

    private determinePercentageWidth(spentNum: number, totalNum: number): number {
        // default to empty budget
        let percentageSpent = 0;
        // don't divide by zero
        if (totalNum !== 0) {
            percentageSpent = determinePercentageIntoRange(spentNum, totalNum);
            if (percentageSpent === 0 && spentNum > 0) {
                // round everything... but a single dollar spent should not show up as empty
                percentageSpent = 1;
            }
        } else {
            // total budget 0? any amount spent = 100% filled
            percentageSpent = spentNum > 0 ? 100 : 0;
        }
        // maximum width is 100, even if overbudget
        return constrainToRange(percentageSpent);
    }
}

export default BudgetBar;